"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var fabric_1 = require("fabric");
var throttle_1 = __importDefault(require("lodash/throttle"));
var constants_1 = require("../common/constants");
var History = /** @class */ (function (_super) {
    __extends(History, _super);
    function History() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redos = [];
        _this.undos = [];
        _this.current = [];
        _this.isActive = false;
        _this.initialize = function () {
            var canvasJSON = _this.canvas.toJSON(_this.config.propertiesToInclude);
            canvasJSON.objects.forEach(function (object) {
                if (object.clipPath) {
                    fabric_1.fabric.util.enlivenObjects([object.clipPath], function (arg1) {
                        object.clipPath = arg1[0];
                    }, "");
                }
            });
            _this.current = canvasJSON.objects;
        };
        _this.getStatus = function () {
            return {
                hasUndo: _this.undos.length >= 1,
                hasRedo: _this.redos.length > 0,
                undos: _this.undos,
                redos: _this.redos,
                state: _this.current,
            };
        };
        _this.save = function () {
            try {
                if (_this.current) {
                    var json = _this.current;
                    _this.undos.push({
                        type: "UPDATE",
                        json: json,
                    });
                    var canvasJSON = _this.canvas.toJSON(_this.config.propertiesToInclude);
                    canvasJSON.objects.forEach(function (object) {
                        if (object.clipPath) {
                            fabric_1.fabric.util.enlivenObjects([object.clipPath], function (arg1) {
                                object.clipPath = arg1[0];
                            }, "");
                        }
                    });
                    _this.current = canvasJSON.objects;
                }
            }
            catch (err) {
                console.log(err);
            }
            _this.emitStatus();
        };
        _this.undo = (0, throttle_1.default)(function () {
            if (_this.undos.length >= 1) {
                var undo = _this.undos.pop();
                if (!undo) {
                    return;
                }
                _this.redos.push({
                    type: "redo",
                    json: _this.current,
                });
                _this.restore(undo);
            }
        }, 100);
        _this.redo = (0, throttle_1.default)(function () {
            var redo = _this.redos.pop();
            if (!redo) {
                return;
            }
            _this.undos.push({
                type: "undo",
                json: _this.current,
            });
            _this.restore(redo);
        }, 100);
        _this.restore = function (transaction) {
            if (!_this.isActive) {
                _this.editor.objects.clear();
                var objects = transaction.json;
                _this.current = objects;
                _this.isActive = true;
                fabric_1.fabric.util.enlivenObjects(objects, function (enlivenObjects) {
                    enlivenObjects.forEach(function (enlivenObject) {
                        if (enlivenObject.type !== constants_1.LayerType.FRAME) {
                            _this.canvas.add(enlivenObject);
                        }
                    });
                    _this.emitStatus();
                }, "");
                _this.isActive = false;
            }
        };
        _this.reset = function () {
            _this.redos = [];
            _this.undos = [];
            _this.emitStatus();
        };
        _this.emitStatus = function () {
            _this.editor.emit("history:changed", {
                hasUndo: _this.undos.length >= 1,
                hasRedo: _this.redos.length > 0,
            });
        };
        return _this;
    }
    Object.defineProperty(History.prototype, "status", {
        get: function () {
            return {
                undos: this.undos,
                redos: this.redos,
                state: this.current,
            };
        },
        enumerable: false,
        configurable: true
    });
    return History;
}(Base_1.default));
exports.default = History;
//# sourceMappingURL=History.js.map